import { render } from "./trend.vue?vue&type=template&id=69e8fc27&scoped=true&ts=true"
import script from "./trend.vue?vue&type=script&lang=ts"
export * from "./trend.vue?vue&type=script&lang=ts"

import "./trend.vue?vue&type=style&index=0&id=69e8fc27&lang=stylus&scoped=true"

import exportComponent from "C:\\work\\pc-customer-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69e8fc27"]])

export default __exports__